"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUsername = exports.getRandomNumber = void 0;
const adjectives_1 = require("./adjectives");
const animals_1 = require("./animals");
const getRandomNumber = (min, max) => (Math.floor(Math.random() * (max - min + 1)) + min);
exports.getRandomNumber = getRandomNumber;
const getRandomItemFromArray = (array) => (0, exports.getRandomNumber)(0, array.length - 1);
const defaultOptions = {
    useHyphen: true,
    useRandomNumber: true
};
const generateUsername = (options = {}) => {
    const newOptions = { ...defaultOptions, ...options };
    const randomAdjective = adjectives_1.adjectives[getRandomItemFromArray(adjectives_1.adjectives)];
    const randomAnimal = animals_1.animals[getRandomItemFromArray(animals_1.animals)];
    const randomNumber = (0, exports.getRandomNumber)(0, 999);
    let username = `${randomAdjective}-${randomAnimal}${randomNumber}`;
    if (!newOptions.useHyphen) {
        username = username.replace('-', '');
    }
    if (!newOptions.useRandomNumber) {
        const matchNumbersRegex = (/[0-9]/g);
        username = username.replace(matchNumbersRegex, '');
    }
    return username;
};
exports.generateUsername = generateUsername;
//# sourceMappingURL=generateUsername.js.map